/* MARMOT: home – „Мармот на живо" (Фаза А2, Порция 5). Vanilla, defer.
   Включва бавното движение САМО когато полароидите преливат контейнера:
   дублира run-а (aria-hidden) за безшевен loop и пуска CSS анимацията.
   При малко снимки – статичен центриран ред. Пауза при hover/докосване
   (CSS), нищо при prefers-reduced-motion. */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(row) {
    if (row.dataset.marmotInit === '1') return;
    row.dataset.marmotInit = '1';
    if (REDUCED.matches) return;

    var track = row.querySelector('.marmot-events__track');
    var run = row.querySelector('.marmot-events__run');
    if (!track || !run) return;

    function arm() {
      var overflowing = run.scrollWidth > row.clientWidth + 8;
      if (overflowing && !row.classList.contains('is-moving')) {
        var clone = run.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
        // Скоростта следва дължината – спокойно „шествие" (~35px/сек).
        var duration = Math.max(30, Math.round(run.scrollWidth / 35));
        track.style.setProperty('--marmot-events-duration', duration + 's');
        row.classList.add('is-moving');
      }
    }

    // Изчакваме снимките да имат размери.
    if (document.readyState === 'complete') arm();
    else window.addEventListener('load', arm, { once: true });
  }

  function initAll() {
    document.querySelectorAll('[data-marmot-events]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
